export default "/images/eb706cd6b65309e33b5ef3f2c78fe928.avif";